import * as filescheduleActions from "../fileschedule_state/fileschedule.actions";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { FileScheduleState,ClientFileScheduleAndContractInfoModel } from '@core/services/client/client.model';
//import * as fromRoot from "../../state/app-state";
import * as fromRoot from "../../../../features.state";
import { id } from '@swimlane/ngx-datatable';

export interface AppState extends fromRoot.FeaturesState {
    fileschedule: FileScheduleState;
}

export const filescheduleAdapter: EntityAdapter<ClientFileScheduleAndContractInfoModel> = createEntityAdapter<ClientFileScheduleAndContractInfoModel>();

export const defaultFileSchedule: FileScheduleState = {
    ids: [],
    entities: {},
    selectedClientId: null,
    loading: false,
    loaded: false,
    error: ""
  };
  
  export const initialState = filescheduleAdapter.getInitialState(defaultFileSchedule);

  export function FileScheduleReducer(
    state = initialState,
    action: filescheduleActions.FileScheduleAction
  ): FileScheduleState {
    switch (action.type) {
   
      case filescheduleActions.ClientFileScheduleActionTypes.LOAD_FILESCHEDULE_SUCCESS: {
        return filescheduleAdapter.addOne(action.payload, {
          ...state,
          selectedClientId: action.payload.id
        });
      } 
  
      case filescheduleActions.ClientFileScheduleActionTypes.LOAD_FILESCHEDULE_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      }
  
      case filescheduleActions.ClientFileScheduleActionTypes.CREATE_FILESCHEDULE_SUCCESS: {
        return filescheduleAdapter.addOne(action.payload, state);
      }

      case filescheduleActions.ClientFileScheduleActionTypes.CREATE_FILESCHEDULE_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      }
  
      case filescheduleActions.ClientFileScheduleActionTypes.UPDATE_FILESCHEDULE_SUCCESS: {
        return filescheduleAdapter.updateOne(action.payload, state);
      }
      
      case filescheduleActions.ClientFileScheduleActionTypes.UPDATE_FILESCHEDULE_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      }
      
      default: {
        return state;
      }
    }
  }
  
   const getFileScheduleFeatureState = createFeatureSelector<FileScheduleState>(
    "fileschedule"
  );
  
  export const getFileSchedules = createSelector(
    getFileScheduleFeatureState,
    filescheduleAdapter.getSelectors().selectAll
  );
  
  export const getFileSchedulesLoading = createSelector(
    getFileScheduleFeatureState,
    (state: FileScheduleState) => state.loading
  );
  
  export const getFileSchedulesLoaded = createSelector(
    getFileScheduleFeatureState,
    (state: FileScheduleState) => state.loaded
  );
  
  export const getError = createSelector(
    getFileScheduleFeatureState,
    (state: FileScheduleState) => state.error
  );
  
  export const getCurrentFileScheduleId = createSelector(
    getFileScheduleFeatureState,
    (state: FileScheduleState) => state.selectedClientId
  );
  export const getCurrentFileSchedule = createSelector(
    getFileScheduleFeatureState,
    getCurrentFileScheduleId,
    state => state.entities[state.selectedClientId]
  );
